import { defineMessages } from 'react-intl';

export default defineMessages({
    completingYourPurchaseMessage: {
        id: 'endorsement.eu.policyChangeDiffPage.Completing your purchase...',
        defaultMessage: 'Completing your purchase...'
    },
    loadingPolicyChangeDiff: {
        id: 'endorsement.eu.policyChangeDiffPage.Loading...',
        defaultMessage: 'Loading...'
    },
    policyChangePhraseTitle: {
        id: 'endorsement.eu.policyChangeDiffPage.Change Phrases',
        defaultMessage: 'Change Phrases'
    },
    changesPhrases: {
        id: 'endorsement.eu.policyDiffPage.Change Phrases',
        defaultMessage: 'Change Phrases'
    },
    issue: {
        id: 'endorsement.eu.policyDiffPage.Issue',
        defaultMessage: 'Issue'
    },
    bindError: {
        id: 'endorsement.eu.config.Unable to bind change',
        defaultMessage: 'Unable to bind change'
    },
    bindErrorMessage: {
        id: 'endorsement.eu.config.An error occurred while attempting to bind changes',
        defaultMessage: 'An error occurred while attempting to bind changes'
    },
    changeConflict: {
        id: 'endorsement.eu.policyChangeDiffPage.tab.Change Conflicts',
        defaultMessage: 'Change Conflicts'
    },
    signature: {
        id: 'endorsement.eu.policyChangeDiffPage.tab.Signature',
        defaultMessage: 'Signature'
    },
    modalError: {
        id: 'e1p.gateway.policychangediff.eu.views.modal.Error',
        defaultMessage: 'Error'
    }
});
